import { User } from '@sr/types';
import React from 'react';
import { Avatar, Link, Text } from '../../ui';

type Props = {
  isDark: boolean;
  user: User;
};

const AccountLink = React.memo<Props>(function AccountLink({
  isDark,
  user,
}: Props) {
  const { firstName, lastName } = user;
  return (
    <Link
      to="/account"
      sx={{
        display: 'flex',
        alignItems: 'center',
        maxWidth: 228,
        padding: 4,
        mr: 3,
      }}
      data-testid="header-account-link"
      id="gi-account-link"
    >
      <Text
        sx={{
          variant: 'text.base',
          mr: 2,
          color: isDark ? 'white50' : 'black50',
          display: ['none', 'none', 'block'],
          transition: 'color 150ms ease-in-out',
        }}
      >
        {firstName} {lastName}
      </Text>
      <Avatar user={user} isDark={isDark} />
    </Link>
  );
});

export default AccountLink;
